module.exports = __webpack_public_path__ + "img/hest10.4bdfc800.jpg";